module.exports = __webpack_public_path__ + "img/black.5fda7691.jpg";